import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import type { MapJob } from './jobPopoverTypes';

interface PopoverProps {
  lat?: number;
  lng?: number;
  data: MapJob;
}

export const Popover = ({ data }: PopoverProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box
      component="table"
      sx={{
        bgcolor: 'rgb(var(--card))',
        border: '1px solid rgb(var(--line))',
        borderRadius: '0px 12px 0px 12px',
        color: 'rgb(var(--ink))',
        borderCollapse: 'collapse',
      }}
    >
      <tbody key={data.id}>
        <tr key={data.id}>
          <Box component="td" sx={{ px: 1.5, py: 0.5, color: 'text.primary' }}>
            {data.make}
            <br /> {data.model}
          </Box>
          <Box component="td" sx={{ px: 1.5, py: 0.5, color: 'text.primary' }}>
            <Box component="span" sx={{ color: 'text.secondary' }}>
              price
            </Box>
            <br />{' '}
            <Box component="span" sx={{ color: 'primary.main' }}>
              ${data.askingPrice}
            </Box>
          </Box>
          <Box component="td" sx={{ px: 1.5, py: 0.5, color: 'text.primary' }}>
            <Box component="span" sx={{ color: 'text.secondary' }}>
              {t('jobs.miles')}
            </Box>
            <br /> {data.distance?.toFixed(2)}
          </Box>
        </tr>
      </tbody>
    </Box>
  );
};
